<template>
  <b-row
    class="custom-fields-row"
  >
    <b-col
      v-for="variable in customVariables"
      :key="variable.id"
      md="6"
      lg="6"
    >
      <b-form-group
        :label="$t(variable.data.label)"
        label-for="h-first-name"
      >
        <vue-timepicker
          v-if="variable.data.type === 'time'"
          v-model="variable.data.value"
          input-width="100%"
          input-class="form-control"
          manual-input
          hide-clear-button
        />
        <b-input-group
          v-else-if="variable.data.type === 'date'"
        >
          <b-form-input
            v-model="variable.data.value"
            type="text"
            placeholder="YYYY-MM-DD"
            autocomplete="off"
            :disabled="true"
            :style="'height: 42px'"
            @input="validateDate(variable.data.id, variable.data.value)"
          />
          <b-input-group-append>
            <b-form-datepicker
              v-model="variable.data.value"
              :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
              trim
              button-only
              right
            />
          </b-input-group-append>
        </b-input-group>
        <b-form-textarea
          v-else-if="variable.data.type === 'multiline string'"
          id="textarea-rows"
          v-model="variable.data.value"
          :placeholder="variable.data.label"
          rows="3"
        />
        <v-select
          v-else-if="variable.data.type === 'select'"
          v-model="variable.data.value"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="variable.data.options.length > 0 ? variable.data.options : airports"
          :reduce="val => val.value"
          :clearable="false"
          multiple
          input-id="debtor-login-status"
        />
        <b-form-radio-group
          v-else-if="variable.data.type === 'boolean'"
          v-model="variable.data.value"
          :options="radioOptions"
          value-field="item"
          text-field="name"
          disabled-field="notEnabled"
          class="demo-inline-spacing"
        />
        <b-form-input
          v-else
          id="h-first-name"
          v-model="variable.data.value"
          :placeholder="variable.data.label"
          :value="variable.customVarValue"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BFormRadioGroup, BFormTextarea, BFormDatepicker, BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import useAppConfig from '@core/app-config/useAppConfig'
import { required } from '@validations'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormTextarea,
    BFormDatepicker,
    vSelect,
    VueTimepicker,
    BInputGroupAppend,
    BInputGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    customVariables: {
      type: Array,
      required: true,
    },
    airports: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      radioOptions: [
        { item: 'true', name: 'True' },
        { item: 'false', name: 'False' },
      ],
    }
  },
  watch: {
    skin: {
      handler() {
        this.timeFieldColor()
      },
    },
  },
  setup() {
    const { skin } = useAppConfig()

    return {
      // Skin
      skin,
    }
  },
  created() {
  },
  mounted() {
    this.timeFieldColor()
  },
  methods: {
    validateDate(index, value) {
      const regex = /^\d{4}-\d{2}-\d{2}$/
      if (!regex.test(value)) {
        document.getElementById(`dateerror-${index}`).style.display = 'block'
      } else {
        document.getElementById(`dateerror-${index}`).style.display = 'none'
      }
    },
    timeFieldColor() {
      const fields = document.getElementsByClassName('time-picker')
      Array.from(fields).forEach(field => {
        const dropdownChildren = field.children[1].classList.contains('dropdown') ? field.children[1] : field.children[2]
        // eslint-disable-next-line no-param-reassign
        dropdownChildren.firstChild.style.backgroundColor = this.skin === 'light' ? 'white' : '#3b4662'
        // eslint-disable-next-line no-param-reassign
        if (this.skin === 'light') {
          dropdownChildren.firstChild.children[0].classList.remove('timepick-hours')
          dropdownChildren.firstChild.children[1].classList.remove('timepick-minutes')
        } else {
          dropdownChildren.firstChild.children[0].classList.add('timepick-hours')
          dropdownChildren.firstChild.children[1].classList.add('timepick-minutes')
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.custom-control.custom-radio {
  margin-top: 5px !important;
}

.generalInfoHeader {
  padding: 0px 0px 20px 0px !important;
  border-bottom: 1px solid #d8d6de !important;
  margin-bottom: 15px !important;
}

.select-list .active {
  background-color: #219289 !important;
}

.timepick-minutes li{
  color: #d0d2d6 !important;
}

.timepick-hours li{
  color: #d0d2d6 !important;;
}

.custom-fields-row {
  margin: 0px;
  margin-bottom: 5px;
  padding: 15px 5px 5px 5px;
  border-top: 1px solid #d8d6de;
  border-bottom: 1px solid #d8d6de;
}
</style>
